/*
 * @Description: 基础路由
 * @Author: shufei
 * @Date: 2021-11-11 20:53:50
 * @LastEditTime: 2021-11-19 23:23:39
 * @LastEditors: shufei
 */
export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home.vue'),
    meta: { title: '首页', keepAlive: false, isTabBar: false }
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: () => import('@/views/privacyAgreement.vue'),
    meta: { title: '用户隐私协议', keepAlive: false, isTabBar: false }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/views/calendar.vue'),
    meta: { title: '赛程日历', keepAlive: false, isTabBar: false }
  },
  {
    path: '/teamIntroduction',
    name: 'teamIntroduction',
    component: () => import('@/views/teamIntroduction.vue'),
    meta: { title: '赛队介绍', keepAlive: false, isTabBar: false }
  },
  {
    path: '/content',
    name: 'content',
    component: () => import('@/views/content.vue'),
    meta: { title: '2025世界人形机器人运动会', keepAlive: false, isTabBar: false }
  },
  {
    path: '/frc',
    name: 'frc',
    component: () => import('@/views/frc.vue'),
    meta: { title: '2025世界人形机器人运动会', keepAlive: false, isTabBar: false }
  },
  {
    path: '/roboMaster',
    name: 'roboMaster',
    component: () => import('@/views/roboMaster.vue'),
    meta: { title: '2025世界人形机器人运动会', keepAlive: false, isTabBar: false }
  }
]
